import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {ifDefined} from 'lit/directives/if-defined.js';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';

@customElement('webs-banner')
export class Banner extends LitElement {

  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    containerStyles,
    css`
    .m-banner {
      background-color: var(--color-dark-grey);
      padding: 0.8rem 0;
    }
    .m-banner .content {
      text-align: center;
    }
    .m-banner p {
      color: var(--color-white);
      font-weight: var(--font-weight-semibold);
      margin: 0;
      font-size: 0.7rem;
      line-height: 1.3 rem;
    }

    @media only screen and (min-width: 576px) {
      .m-banner .content {
        align-items: center;
        display: flex;
        place-content: center;
      }
      .m-banner p {
        margin-right: 1.2rem;
      }
    }
    `
  ]

  @property()
  id: string;

  @property()
  text = "Registrations for our the future of Ecommerce event are open";

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  protected render(): unknown {
    return html`
    <section id="${ifDefined(this.id)}" class="m-banner ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="content">
          <p>${this.text}</p>
          <slot name="tag"></slot>
        </div>
    </section>
    `
  }
}
